module.exports = __webpack_public_path__ + "img/icon3.fa77f2d.png";